export default __webpack_public_path__ + "static/media/NSS-1.a093002d.jpg";